import { Box, CircularProgress, Grid, Typography } from '@mui/material';

interface IProps {
  messages?: string[];
  showItem?: 'spinner' | 'none';
}

const cssClasses = {
  healix: {
    height: '37px',
    marginTop: '36px',
    marginBottom: '18px',
  },
  spinner: {
    marginTop: '36px',
    marginBottom: '18px',
    alignSelf: 'center',
  },
};

export function Loading(props: IProps) {
  const { messages, showItem } = props;
  const anim = showItem || 'spinner';
  return (
    <Grid container direction="column" alignContent="center">
      {anim === 'spinner' && (
        <Box sx={cssClasses.spinner}>
          <CircularProgress />
        </Box>
      )}
      {messages && (
        <Box>
          {messages.map((message) => {
            return (
              <Typography key={message} align="center">
                {message}
              </Typography>
            );
          })}
        </Box>
      )}
    </Grid>
  );
}
